import { createContext } from 'react';

export const SearchRandomizedFeedsContext = createContext(null);

export const EMPTY_SEARCH_RANDOMIZED_FEED = Object.freeze({
  hasRequested: false,
  loading: false,
  loadingMore: false,
  data: [],
  listLengthHint: 0,
  hasMore: false,
  cursor: null,
  seed: null,
  error: null,
});

export function getSearchRandomizedFeedState(feeds, feedKey) {
  return feeds[feedKey] ?? EMPTY_SEARCH_RANDOMIZED_FEED;
}
